// extracted by mini-css-extract-plugin
export default {"container":"OrderPreviewLayout_container__8eOHF","footer":"OrderPreviewLayout_footer__hWUOR","footer__actions":"OrderPreviewLayout_footer__actions__2oCXM"};